import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

interface BasicCodeBlockProps {
  children: string;
  className?: string;
}

const BasicCodeBlock: React.FC<BasicCodeBlockProps> = ({ children, className }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(children);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative group my-4">
      <div className="absolute right-2 top-2 opacity-0 group-hover:opacity-100 transition-opacity z-10">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleCopy}
          className="p-2 rounded-md bg-white/10 hover:bg-white/20 transition-colors"
        >
          <AnimatePresence mode="wait" initial={false}>
            {copied ? (
              <motion.div
                key="check"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0 }}
              >
                <Check className="w-4 h-4 text-green-400" />
              </motion.div>
            ) : (
              <motion.div
                key="copy"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0 }}
              >
                <Copy className="w-4 h-4 text-gray-300" />
              </motion.div>
            )}
          </AnimatePresence>
        </motion.button>
      </div>
      <pre className="bg-black text-gray-300 rounded-lg p-4 overflow-x-auto font-mono text-sm leading-relaxed border shadow-sm">
        <code className={className}>
          {children}
        </code>
      </pre>
    </div>
  );
};

export default BasicCodeBlock;
